import { MessageMedia } from 'utils/gloo-types';
import { MediaUploadResult } from 'components/organisms/CloudinaryMediaUploader';

export const formatMMSMedia = (mmsMedia: MediaUploadResult): MessageMedia[] => {
  if (mmsMedia?.info) {
    return [
      {
        url: `http://res.cloudinary.com/thryve/image/upload/c_limit,h_0.4,w_0.4/c_crop,g_custom/${mmsMedia.info.path}`,
        cloudinaryId: mmsMedia.info.public_id,
        resourceType: 'image',
      },
    ];
  }
  return [];
};

export interface CloudinaryDto {
  open: () => void;
  destroy: (id: string) => void;
}

export interface MediaUploadDto {
  info?: {
    public_id: string;
    url: string;
  };
}
